import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
var styles = {
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      width: 100%;\n      height: 100%;\n      flex-direction: column;\n      display: flex;\n      justify-content: flex-end;\n      border-radius: ", ";\n      overflow: hidden;\n      padding-bottom: ", ";\n      background: ", ";\n    "])), t.mobilePopupContainerBorderRadius, t.mobilePopupContainerBottomPadding, t.menuBgDefault);
  },
  wrapper: function wrapper() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      right: 0;\n      left: 0;\n      overflow: auto;\n    "])));
  },
  content: function content(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      background-color: ", ";\n    "])), t.bgDefault);
  },
  container: function container(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      position: absolute;\n      top: ", ";\n      left: ", ";\n      right: ", ";\n      z-index: 100000;\n    "])), t.mobilePopupTopPadding, t.mobilePopupOuterIndentY, t.mobilePopupOuterIndentY);
  },
  bg: function bg() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      right: 0;\n      left: 0;\n      z-index: 9999;\n      background: #333333;\n      pointer-events: none;\n      opacity: 50%;\n    "])));
  },
  bottomIndent: function bottomIndent() {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      height: 80px;\n    "])));
  },
  zIndex: function zIndex() {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      position: relative;\n    "])));
  }
};
export var jsStyles = memoizeStyle(styles);